import { render, staticRenderFns } from "./goods-image.vue?vue&type=template&id=7f2e917e&scoped=true"
import script from "./goods-image.vue?vue&type=script&lang=js"
export * from "./goods-image.vue?vue&type=script&lang=js"
import style0 from "./goods-image.vue?vue&type=style&index=0&id=7f2e917e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e917e",
  null
  
)

export default component.exports